import type { AllFeatureIds } from 'generated/featureIds.generated'
import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

const LEGAL_ENTITY_ID_KEY = 'id'

export interface LegalEntitySettingsAtributes extends Record<AllFeatureIds, boolean> {
  [LEGAL_ENTITY_ID_KEY]: number
}

class LegalEntitySettings extends Model<LegalEntitySettingsAtributes> {
  static urlRoot() {
    return '/bookkeepers_management/legal_entities_settings'
  }

  constructor(attr: LegalEntitySettingsAtributes) {
    super(attr)
    makeObservable(this, {
      features: computed,
      id: computed,
    })
  }

  get features() {
    return Object.fromEntries(
      Object.entries(this.attributes).filter(([key]) => key !== LEGAL_ENTITY_ID_KEY)
    ) as Record<AllFeatureIds, boolean>
  }

  hasFeature(feature: AllFeatureIds) {
    return this.attributes[feature]
  }

  get legalEntityId() {
    return this.attributes[LEGAL_ENTITY_ID_KEY]
  }
}

export default LegalEntitySettings
